import React from 'react';
import Calculadora from './Calculadora';

function App() {
  return (
    <div className="App">
      <Calculadora />
    </div>
  );
}

export default App;
